export const formEl = [
  {
    label: "Text",
    value: "text",
  },
  {
    label: "TextArea",
    value: "textarea",
  },
  {
    label: "Radio",
    value: "radio",
  },
  {
    label: "Checkbox",
    value: "checkbox",
  },
  {
    label: "Date",
    value: "date",
  },

];
